import { useCallback, useEffect, useState } from 'react';
import { useBlocker } from 'react-router-dom';

const useCallbackPrompt = (when: boolean, handleSave: () => void) => {
	const [showPrompt, setShowPrompt] = useState(false);

	const blocker = useBlocker(when);

	// Quand une navigation est bloquée, afficher le prompt
	useEffect(() => {
		if (blocker.state === 'blocked') {
			setShowPrompt(true);
		}
	}, [blocker.state]);

	const navigateOut = useCallback(() => {
		setShowPrompt(false);
		blocker.proceed?.();
	}, [blocker]);

	const saveAndQuit = useCallback(() => {
		if (handleSave) {
			handleSave();
		}
		navigateOut();
	}, [handleSave, navigateOut]);

	const quitWithoutSaving = useCallback(() => {
		navigateOut();
	}, [navigateOut]);

	// Si l'utilisateur annule (reste sur la page)
	const cancelNavigation = useCallback(() => {
		setShowPrompt(false);
		blocker.reset?.();
	}, [blocker]);

	return { cancelNavigation, quitWithoutSaving, saveAndQuit, showPrompt };
};

export default useCallbackPrompt;
